const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createShoppingList = async (items) => {
  const response = await fetch(`${API_URL}/api/shopping-lists`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível criar a lista, tente novamente.')
  return data.id
}

// Fetches the current items once, then opens an SSE stream for live
// updates — only after confirming the list actually exists, so we don't
// leave a dangling EventSource retrying against a 404 forever.
export const subscribeToShoppingList = (id, onChange) => {
  let cancelled = false
  let eventSource = null

  fetch(`${API_URL}/api/shopping-lists/${id}`)
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      if (cancelled) return
      if (!data) {
        onChange(null)
        return
      }
      onChange(data.items)

      eventSource = new EventSource(`${API_URL}/api/shopping-lists/${id}/stream`)
      eventSource.onmessage = (event) => {
        if (!cancelled) onChange(JSON.parse(event.data).items)
      }
    })
    .catch(() => {
      if (!cancelled) onChange(null)
    })

  return () => {
    cancelled = true
    if (eventSource) eventSource.close()
  }
}

export const updateShoppingListItems = (id, items) =>
  fetch(`${API_URL}/api/shopping-lists/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  })
